<template>
  <transition name="fade" mode="out-in">
    <ModalWindow
      v-if="isSupportModal"
      title="Contact technical support"
      customWrapperClass="bb-modal-wrapper__small-padding"
      :centerTitle="true"
      :withoutPaddingTitle="true"
      :withoutPaddingChild="true"
      :isFooter="true"
      :isFooterMargin="true"
      buttonRightName="SEND"
      @close="close"
      @handlerClick="handlerClick"
    >
      <BBForm
        class="technical-support-modal-form"
        :inputs="inputs"
        @update="update"
      />
    </ModalWindow>
  </transition>
</template>

<script>
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import BBForm from '@/components/Main/BBForm/BBForm'
import technicalSupportInputs from '@/constants/Forms/technicalSupportForm'
import TechnicalSupportApi from '@/api/TechnicalSupport/api'
import UploadFileApi from '@/api/UploadFile/api'
import setFileData from '@/mixin/setFileData'
import {STATUS_TECHNICAL_SUPPORT} from '@/constants/statusTechnicalSupport'
import {
  SOFTWARE_BUG_ID,
  SOFTWARE_BUG_TITLE,
  SOFTWARE_SUGGESTION_TITLE
} from "../../../constants/categoryTechnicalSupport";

export default {
  name: 'TechnicalSupportModal',
  components: {
    BBForm,
    ModalWindow
  },
  props: {
    isSupportModal: {
      type: Boolean,
      default: false
    },
    loader: {
      type: Boolean,
      default: false
    }
  },
  mixins: [setFileData],
  data: () => ({
    inputs: JSON.parse(JSON.stringify(technicalSupportInputs)),
    body: {}
  }),
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    close (status) {
      this.$emit('close', status)
    },
    update ({ model }) {
      this.body = model
    },
    async createBody () {
      const { uploadFile } = this.body
      const { _id } = this.userInfo
      const { NOT_ACTIVE } = STATUS_TECHNICAL_SUPPORT

      let uploadFileId = []
      if (uploadFile) {
        // eslint-disable-next-line no-return-await
        const promises = uploadFile.map(async (item) => await this.uploadFile(item))
        uploadFileId = await Promise.all(promises)
      }

      return {
        ...this.body,
        date: new Date(),
        user: _id,
        status: NOT_ACTIVE,
        uploadFile: uploadFileId
      }
    },
    async handlerClick () {
      this.$emit('update:loader', true)
      const body = await this.createBody();
      try {
        const { data } = await TechnicalSupportApi.createTechnicalSupport(body);

        this.$store.dispatch('setNewTechnicalSuggestion', {
          ...data,
          category: data.category === SOFTWARE_BUG_ID ? SOFTWARE_BUG_TITLE : SOFTWARE_SUGGESTION_TITLE
        });

        this.$emit('update:loader', false);
        this.close(200)
      } catch (err) {
        console.error(err)
        this.$emit('update:loader', false)
        this.close(500)
      }
    },
    async uploadFile (fileData) {
      const { id, _id, fileSize } = fileData
      if (!fileSize) return id || _id
      const file = this.setFileData(fileData)
      try {
        const { data } = await UploadFileApi.createFile(file, true)
        const { id, _id } = data
        return id || _id
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style scoped lang="scss">

  .technical-support-modal-form {
    width: 484px;
    margin: 18px 0 34px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/TechnicalSupport/TechnicalSupportModal/TechnicalSupportModal.vue